module.exports = __webpack_public_path__ + "static/media/iPhone14-5.0e9bcc3c.png";